var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.7786,
    height: 39,
    rx: 10.2295,
    fill: "#F7F6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_14190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2466 18.3266C23.6437 16.6524 22.6083 14.9733 20.934 14.5763C19.2598 14.1793 17.5807 15.2147 17.1837 16.8889C16.7867 18.5632 17.8221 20.2422 19.4963 20.6393C21.1706 21.0363 22.8496 20.0009 23.2466 18.3266Z",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.831 22.5386H22.5952C23.9735 22.5386 25.0903 23.6554 25.0903 25.0337V26.0574H15.3359V25.0337C15.3359 23.6554 16.4527 22.5386 17.831 22.5386Z",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0938 12.9429V15.633",
    stroke: "#0D4248",
    strokeWidth: 0.739372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 14.2861H26.4401",
    stroke: "#0D4248",
    strokeWidth: 0.739372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_14190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.988,
    height: 14,
    fill: "white",
    transform: "translate(14.8945 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.93c4d8291a03644be679ed91ede67c86.svg";
export { ForwardRef as ReactComponent };